var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 15.9167V26.7083C30.5 28.8024 28.8024 30.5 26.7083 30.5H13.2917C11.1976 30.5 9.5 28.8024 9.5 26.7083V15.9167H30.5ZM14.4583 23.5C13.6529 23.5 13 24.1529 13 24.9583C13 25.7637 13.6529 26.4167 14.4583 26.4167C15.2637 26.4167 15.9167 25.7637 15.9167 24.9583C15.9167 24.1529 15.2637 23.5 14.4583 23.5ZM20 23.5C19.1946 23.5 18.5417 24.1529 18.5417 24.9583C18.5417 25.7637 19.1946 26.4167 20 26.4167C20.8054 26.4167 21.4583 25.7637 21.4583 24.9583C21.4583 24.1529 20.8054 23.5 20 23.5ZM14.4583 18.25C13.6529 18.25 13 18.9029 13 19.7083C13 20.5137 13.6529 21.1667 14.4583 21.1667C15.2637 21.1667 15.9167 20.5137 15.9167 19.7083C15.9167 18.9029 15.2637 18.25 14.4583 18.25ZM20 18.25C19.1946 18.25 18.5417 18.9029 18.5417 19.7083C18.5417 20.5137 19.1946 21.1667 20 21.1667C20.8054 21.1667 21.4583 20.5137 21.4583 19.7083C21.4583 18.9029 20.8054 18.25 20 18.25ZM25.5417 18.25C24.7363 18.25 24.0833 18.9029 24.0833 19.7083C24.0833 20.5137 24.7363 21.1667 25.5417 21.1667C26.3471 21.1667 27 20.5137 27 19.7083C27 18.9029 26.3471 18.25 25.5417 18.25ZM26.7083 9.5C28.8024 9.5 30.5 11.1976 30.5 13.2917V14.1667H9.5V13.2917C9.5 11.1976 11.1976 9.5 13.2917 9.5H26.7083Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.2404c68fde9aaebec3e0e990c30124ae.svg";
export { ForwardRef as ReactComponent };